import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nopage',
  templateUrl: './nopage.component.html',
  styleUrls: ['./nopage.component.scss']
})
export class NopageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
